"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.object.to-string.js");
var _default = exports.default = {
  methods: {
    /** 获取树节点 label
     * @description: 获取树节点 label
     * @return { void }
     */
    getTreeLabel: function getTreeLabel() {
      var _ref, _ref2, _ref3, _this$$attrs$tree$pro, _this$$attrs$tree, _this$treeProps;
      return (_ref = (_ref2 = (_ref3 = (_this$$attrs$tree$pro = (_this$$attrs$tree = this.$attrs.tree) === null || _this$$attrs$tree === void 0 || (_this$$attrs$tree = _this$$attrs$tree.props) === null || _this$$attrs$tree === void 0 ? void 0 : _this$$attrs$tree.label) !== null && _this$$attrs$tree$pro !== void 0 ? _this$$attrs$tree$pro : this.$attrs.treeLabel) !== null && _ref3 !== void 0 ? _ref3 : this.$attrs.label) !== null && _ref2 !== void 0 ? _ref2 : (_this$treeProps = this.treeProps) === null || _this$treeProps === void 0 ? void 0 : _this$treeProps.label) !== null && _ref !== void 0 ? _ref : 'label';
    },
    /** 树节点筛选
     * @description: 树节点筛选
     * @param { * } value 筛选条件
     * @return { void }
     */
    treeFilter: function treeFilter() {
      var _this$$refs$elTree;
      (_this$$refs$elTree = this.$refs['el-tree']) === null || _this$$refs$elTree === void 0 || _this$$refs$elTree.filter(this.treeFilterValue);
    },
    /** 树节点筛选方法
     * @description: 对树节点进行筛选时执行的方法，返回 true 表示这个节点可以显示，返回 false 则表示这个节点会被隐藏
     * @param { * } value 筛选条件
     * @param { Object } data 数据对象
     * @param { Object<Node> } node 节点
     * @return { Boolean } 当前节点是否可以显示
     */
    filterNodeMethod: function filterNodeMethod(value, data /* , node */) {
      var _data$this$getTreeLab;
      if (!value) return true;
      return ((_data$this$getTreeLab = data[this.getTreeLabel()]) === null || _data$this$getTreeLab === void 0 ? void 0 : _data$this$getTreeLab.indexOf(value)) !== -1;
    }
  }
};